"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var forEachClassName = function forEachClassName(classNames, cb) {
  classNames.trim().split(/\s+/).forEach(function (className) {
    cb(className);
  });
};
/**
 * Passes the child component through directly, while toggling
 * the body class according to the bodyClassName prop
 */


var _default = _react.default.createClass({
  displayName: "ComponentWithBodyClass",
  propTypes: {
    bodyClassName: _react.PropTypes.string.isRequired,
    bodyElement: _react.PropTypes.object.isRequired,
    children: _react.PropTypes.node
  },
  getDefaultProps: function getDefaultProps() {
    return {
      bodyElement: document.body
    };
  },
  componentDidMount: function componentDidMount() {
    this.toggleBodyClass(true, this.props.bodyClassName);
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var bodyClassName = _ref.bodyClassName;

    if (bodyClassName !== this.props.bodyClassName) {
      this.toggleBodyClass(false, this.props.bodyClassName);
      this.toggleBodyClass(true, bodyClassName);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.toggleBodyClass(false, this.props.bodyClassName);
  },
  toggleBodyClass: function toggleBodyClass(isMounting, bodyClassName) {
    var bodyElement = this.props.bodyElement;

    if (bodyClassName && bodyElement) {
      var func = isMounting ? 'add' : 'remove';
      forEachClassName(bodyClassName, function (className) {
        bodyElement.classList[func](className);
      });
    }
  },
  render: function render() {
    return _react.Children.only(this.props.children);
  }
});

exports.default = _default;
module.exports = exports.default;